__turbopack_context__.v({
  "aiCard": "MagicWandModal-module__JZhUta__aiCard",
  "aiCardHead": "MagicWandModal-module__JZhUta__aiCardHead",
  "aiCatTag": "MagicWandModal-module__JZhUta__aiCatTag",
  "aiCost": "MagicWandModal-module__JZhUta__aiCost",
  "aiCostFree": "MagicWandModal-module__JZhUta__aiCostFree",
  "aiCostHigh": "MagicWandModal-module__JZhUta__aiCostHigh",
  "aiDesc": "MagicWandModal-module__JZhUta__aiDesc",
  "aiFoot": "MagicWandModal-module__JZhUta__aiFoot",
  "aiGrid": "MagicWandModal-module__JZhUta__aiGrid",
  "aiIco": "MagicWandModal-module__JZhUta__aiIco",
  "aiName": "MagicWandModal-module__JZhUta__aiName",
  "aiNum": "MagicWandModal-module__JZhUta__aiNum",
  "aiRun": "MagicWandModal-module__JZhUta__aiRun",
  "badgeNew": "MagicWandModal-module__JZhUta__badgeNew",
  "comboCard": "MagicWandModal-module__JZhUta__comboCard",
  "comboCost": "MagicWandModal-module__JZhUta__comboCost",
  "comboEmoji": "MagicWandModal-module__JZhUta__comboEmoji",
  "comboFoot": "MagicWandModal-module__JZhUta__comboFoot",
  "comboHead": "MagicWandModal-module__JZhUta__comboHead",
  "comboSteps": "MagicWandModal-module__JZhUta__comboSteps",
  "comboTx": "MagicWandModal-module__JZhUta__comboTx",
  "emptyState": "MagicWandModal-module__JZhUta__emptyState",
  "featured": "MagicWandModal-module__JZhUta__featured",
  "filterPill": "MagicWandModal-module__JZhUta__filterPill",
  "filterPills": "MagicWandModal-module__JZhUta__filterPills",
  "filterRow": "MagicWandModal-module__JZhUta__filterRow",
  "filterSearch": "MagicWandModal-module__JZhUta__filterSearch",
  "groupCount": "MagicWandModal-module__JZhUta__groupCount",
  "groupLabel": "MagicWandModal-module__JZhUta__groupLabel",
  "groupTitle": "MagicWandModal-module__JZhUta__groupTitle",
  "hBalance": "MagicWandModal-module__JZhUta__hBalance",
  "hClose": "MagicWandModal-module__JZhUta__hClose",
  "hRunAll": "MagicWandModal-module__JZhUta__hRunAll",
  "hSpacer": "MagicWandModal-module__JZhUta__hSpacer",
  "hTitle": "MagicWandModal-module__JZhUta__hTitle",
  "mmlTag": "MagicWandModal-module__JZhUta__mmlTag",
  "mw": "MagicWandModal-module__JZhUta__mw",
  "mwBackdrop": "MagicWandModal-module__JZhUta__mwBackdrop",
  "mwBody": "MagicWandModal-module__JZhUta__mwBody",
  "mwCenter": "MagicWandModal-module__JZhUta__mwCenter",
  "mwHeader": "MagicWandModal-module__JZhUta__mwHeader",
  "mwRight": "MagicWandModal-module__JZhUta__mwRight",
  "on": "MagicWandModal-module__JZhUta__on",
  "recentList": "MagicWandModal-module__JZhUta__recentList",
  "recentMeta": "MagicWandModal-module__JZhUta__recentMeta",
  "recentName": "MagicWandModal-module__JZhUta__recentName",
  "recentRow": "MagicWandModal-module__JZhUta__recentRow",
  "rightBlock": "MagicWandModal-module__JZhUta__rightBlock",
  "rightTitle": "MagicWandModal-module__JZhUta__rightTitle",
  "used": "MagicWandModal-module__JZhUta__used",
});
